import { TableFilter } from './table-filter';
import { TableSelectionState } from './table-selection-state';
import { TableSort } from './table-sort';
import { TableState } from './table-state';
import { TableElement } from './types';

export class TableDataTransform<T extends Record<string, unknown>> {
  constructor(
    private readonly data: T[],
    private readonly selecteds: TableSelectionState<T>,
    private readonly state: TableState,
    private readonly trackBy?: keyof T
  ) {}

  public elements(): TableElement<T>[] {
    const field = this.state.sort.field as keyof T;
    const sort = TableSort.from(this.state.sort.type);
    const filter = TableFilter.from<T>(this.state);

    return [...this.data]
      .filter((element) => filter.allow(element))
      .sort((a, b) => sort.order(a[field], b[field]))
      .map((element, index) => {
        const key = this.selecteds.selectedBy
          ? element[this.selecteds.selectedBy]
          : index;

        const trackBy = this.trackBy ? element[this.trackBy] : index;

        return {
          key,
          trackBy,
          data: element,
          selected: this.selecteds.selected(key),
          hide: this.selecteds.hideFor.includes(key),
        };
      });
  }
}
